import { render, staticRenderFns } from "./UserAssociateOrg.vue?vue&type=template&id=643b7888&"
import script from "./UserAssociateOrg.vue?vue&type=script&lang=js&"
export * from "./UserAssociateOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/users/UserAssociateOrg.vue
// module id = 1445
// module chunks = 0